import API from "..";
import { Role } from '../getSelf';

export interface User {
  id: string;
  email: string;
  role: Role;
}

export const getChannelUsers = async (id: string) => API.get<User[]>(`/channel/${id}/users`);